
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import BasketModule from '@/store/modules/basket';
import UserModule from '@/store/modules/user';

@Component({
  components: {},
})
export default class ApplyPromotions extends Vue {
  @Getter activeRestaurant: Restaurant;

  selectedReward: string;
  isPromotionLoading: boolean;

  couponForm: {
    code: string;
  };

  data() {
    return {
      couponForm: {
        amount: null
      },
      isPromotionLoading: false,
      selectedReward: null
    }
  }

  created() {
    try {
      if (UserModule.loggedIn && this.activeRestaurant?.id) {
        UserModule.getRewards(this.activeRestaurant.id);
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    }
  }

  @Watch('activeRestaurant.id')
  handleActiveRestaurantChange(newValue, oldValue) {
    if (newValue && newValue !== oldValue) {
      if (UserModule.loggedIn) {
        UserModule.getRewards(newValue);
      }
    }
  }

  async applyCoupon(model) {
    try {
      this.isPromotionLoading = true;

      const { code } = model;
      await BasketModule.addCoupon({ basketId: BasketModule.id, couponCode: code });
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      this.isPromotionLoading = false;
    }
  }

  async applyReward() {
    try {
      const reward = UserModule.availableRewards?.find((reward) => reward.reference === this.selectedReward);
      if (!reward) {
        return this.$log.error('Error finding reward to apply');
      }
      this.isPromotionLoading = true;

      await BasketModule.addReward({ basketId: BasketModule.id, membershipId: reward.membershipId, referenceId: reward.reference });
      await BasketModule.validateBasket({ basketId: BasketModule.id });
      await BasketModule.getBasket(BasketModule.id);
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      this.isPromotionLoading = false;
    }
  }

  async handleRemovePromotion() {
    try {
      this.isPromotionLoading = true;

      if (BasketModule.appliedRewards && BasketModule.appliedRewards.length > 0) {
        const rewardId = BasketModule.appliedRewards[0]?.rewardId;
        if (rewardId) {
          await BasketModule.removeReward({ basketId: BasketModule.id, rewardId });
        }
      } else {
        await BasketModule.removeCoupon({ basketId: BasketModule.id });
      }
      await BasketModule.validateBasket({ basketId: BasketModule.id });
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      this.isPromotionLoading = false;
    }
  }

  get isLoggedIn() {
    return UserModule.loggedIn;
  }

  get availableRewards() {
    return UserModule.availableRewards?.map(({ label, reference }: LoyaltyReward) => ({ label, value: reference })) || null;
  }

  get appliedReward() {
    return BasketModule.appliedRewards;
  }

  get appliedDiscounts() {
    return BasketModule.appliedDiscounts;
  }

  get isPromotionApplied() {
    return BasketModule.appliedDiscounts?.length > 0 || false;
  }
}
